const REMINDER_EVENT_DURATION_MS = 15 * 60 * 1000;
const REMINDER_HOUR = 9;
const SUNDAY = 0;
const SATURDAY = 6;

function padDatePart (value) {
    return String(value).padStart(2, '0');
}

// Google reads this as wall-clock time in `ctz`. A trailing `Z` would force UTC
// and shift the reminder off 9am for anyone outside it.
function toGoogleCalendarDate (date) {
    const day = `${date.getFullYear()}${padDatePart(date.getMonth() + 1)}${padDatePart(date.getDate())}`;
    const time = `${padDatePart(date.getHours())}${padDatePart(date.getMinutes())}${padDatePart(date.getSeconds())}`;

    return `${day}T${time}`;
}

function getLocalTimeZone () {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

function getNextUpcomingReminder (now) {
    const next = new Date(now);

    next.setHours(REMINDER_HOUR, 0, 0, 0);

    if (next.getTime() < now) {
        next.setDate(next.getDate() + 1);
    }

    return next;
}

export function getReminderStart (expiresAt, now = Date.now()) {
    const start = new Date(expiresAt);

    start.setDate(start.getDate() - 1);

    const dayOfWeek = start.getDay();
    if (dayOfWeek === SATURDAY) {
        start.setDate(start.getDate() - 1);
    } else if (dayOfWeek === SUNDAY) {
        start.setDate(start.getDate() - 2);
    }

    start.setHours(REMINDER_HOUR, 0, 0, 0);

    if (start.getTime() >= now) {
        return start;
    }

    // Short-lived grants can put the reminder in the past. Move it to the next 9am,
    // but never past the expiration itself, since a reminder that fires after access
    // is revoked is useless. Weekends are not skipped for the same reason.
    const clamped = getNextUpcomingReminder(now);

    return clamped.getTime() > expiresAt ? new Date(expiresAt) : clamped;
}

export function buildGoogleCalendarEventUrl ({ title, details, start, end, timeZone }) {
    const params = new URLSearchParams({
        action: 'TEMPLATE',
        text: title,
        dates: `${toGoogleCalendarDate(start)}/${toGoogleCalendarDate(end)}`,
        details,
        crm: 'AVAILABLE',
    });

    if (timeZone) {
        params.set('ctz', timeZone);
    }

    return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function buildGuestAccessReminderUrl ({ title, details, expiresAt, timeZone = getLocalTimeZone(), now }) {
    const start = getReminderStart(expiresAt, now);
    const end = new Date(start.getTime() + REMINDER_EVENT_DURATION_MS);

    return buildGoogleCalendarEventUrl({ title, details, start, end, timeZone });
}
